import { useQuery } from '@tanstack/react-query';

import { posthog } from '$src/utils';

export const FEATURE_FLAG_QUERY_KEY = 'QUERY/FEATURE_FLAG_QUERY_KEY';

export function useFeatureFlag(featureFlagName: string) {
  return useQuery({
    queryKey: [FEATURE_FLAG_QUERY_KEY, featureFlagName],
    queryFn: async (): Promise<boolean | string | undefined> => {
      return await posthog.getFeatureFlag(featureFlagName);
    },
  });
}
